import { render, staticRenderFns } from "./BaseFooter.vue?vue&type=template&id=609355f1&scoped=true&"
import script from "./BaseFooter.vue?vue&type=script&lang=ts&"
export * from "./BaseFooter.vue?vue&type=script&lang=ts&"
import style0 from "./BaseFooter.vue?vue&type=style&index=0&id=609355f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609355f1",
  null
  
)

export default component.exports